var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShootPlayerLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 77,
    viewBox: "0 0 76 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 24"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse 6",
    cx: 39.3989,
    cy: 70.125,
    rx: 36.5,
    ry: 6,
    fill: "url(#paint0_linear_68_174345)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.0382309 7.87635C0.173679 8.75955 0.643116 9.53699 1.36118 10.0677L15.1937 20.616C15.3199 22.4752 15.5351 30.3609 15.6576 35.5117C15.1269 36.3355 13.0692 39.2542 11.2341 41.8537C4.82162 50.9455 4.81977 51.0234 4.80121 51.5188V67.756C4.75111 69.5577 6.28373 71.1293 8.15776 71.1942C8.19672 71.1961 8.23754 71.1961 8.27465 71.1961C10.08 71.1961 11.544 69.7878 11.6164 67.9842L12.6591 52.3055L21.0551 41.9799C23.1759 43.8131 29.1988 49.2496 33.1064 52.801C34.2141 53.9142 35.9675 54.1053 37.2905 53.2518L49.2657 45.5349C50.815 44.5348 51.264 42.4623 50.2639 40.9111C49.2712 39.3692 47.2135 38.9183 45.6661 39.8943L36.1568 45.3178C32.5887 41.7832 27.4379 36.6268 26.3618 35.4171V25.4996L36.5409 34.4077C37.0326 34.853 38.0716 35.2705 39.1311 35.213C39.9976 35.1684 40.7416 34.8178 41.2779 34.198C42.4951 32.7953 42.4097 30.7302 41.0849 29.4981L25.9573 15.3817C25.7569 15.1943 25.4953 15.0904 25.2206 15.0904H25.2188C23.1741 15.0923 20.2517 15.0923 19.2572 15.0923L5.33373 4.6868C4.60824 4.15242 3.72504 3.93533 2.84184 4.06707C1.95864 4.20066 1.17934 4.6701 0.650532 5.39002C0.121723 6.10994 -0.0953636 6.99314 0.0382309 7.87635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.3771 6.12119C15.3771 9.49443 18.1232 12.2405 21.4983 12.2405C24.8716 12.2405 27.6177 9.49443 27.6177 6.12119C27.6177 2.74609 24.8716 0 21.4983 0C18.1232 0 15.3771 2.74609 15.3771 6.12119Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M14.8933 65.1289C14.8933 68.504 17.6394 71.25 21.0126 71.25C24.3877 71.25 27.1338 68.504 27.1338 65.1289C27.1338 61.7556 24.3877 59.0095 21.0126 59.0095C17.6394 59.0095 14.8933 61.7556 14.8933 65.1289Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_68_174345",
    x1: 2.89893,
    y1: 70.125,
    x2: 75.8989,
    y2: 70.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShootPlayerLeft);
export default __webpack_public_path__ + "static/media/shoot-player-left.3ff0dad0e5e609fc20c0f799196a5445.svg";
export { ForwardRef as ReactComponent };